// Trial check mirroring useSubscriptionStatus.js (supports ms epoch or ISO string).
// Pure given an explicit `nowMs`; the default reads current wall-clock time for caller convenience.
export function getIsOrgOnTrial(
  trialEndTimestamp: number | string | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  if (trialEndTimestamp == null) return false;
  const trialEndMs =
    typeof trialEndTimestamp === 'string' ? Date.parse(trialEndTimestamp) : trialEndTimestamp;
  return Number.isFinite(trialEndMs) && nowMs <= trialEndMs;
}
